import { defaultAuthState } from '../reducers/authReducer'
import { defaultBlobState } from '../reducers/blobReducer'
import { defaultCustomerState } from '../reducers/customerReducer'
import { defaultDeviceState } from '../reducers/deviceReducer'
import { defaultErrorState } from '../reducers/errorReducer'
import { defaultJobState } from '../reducers/jobReducer'
import { defaultLodingState } from '../reducers/loadingReducer'
import { defaultNavigationState } from '../reducers/navigationReducer'
import { defaultPasswordresetState } from '../reducers/passwordresetReducer'
import { defaultProfileState } from '../reducers/profileReducer'
import { defaultReportState } from '../reducers/reportReducer'
import { defaultResultState } from '../reducers/resultReducer'
import { defaultSettingState } from '../reducers/settingReducer'
import { defaultTestsState } from '../reducers/testsReducer'
import { defaultUserState } from '../reducers/userReducer'

const RESET_REDUCERS = 'RESET_REDUCERS'
export const resetAllReducers = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let state = getState()

      state.authReducer = defaultAuthState
      state.blobReducer = defaultBlobState
      state.customerReducer = defaultCustomerState
      state.deviceReducer = defaultDeviceState
      state.errorReducer = defaultErrorState
      state.jobReducer = defaultJobState
      state.loadingReducer = defaultLodingState
      state.navigationReducer = defaultNavigationState
      state.passwordresetReducer = defaultPasswordresetState
      state.profileReducer = defaultProfileState
      state.reportReducer = defaultReportState
      state.resultReducer = defaultResultState
      state.settingReducer = defaultSettingState
      state.testsReducer = defaultTestsState
      state.userReducer = defaultUserState

      dispatch({
        type: RESET_REDUCERS,
        state
      })
      resolve(true)
    })
  }
}
export const resetReducersOnImpersonate = () => {
  return (dispatch, getState) => {
    let state = getState()
    state.blobReducer = defaultBlobState
    state.customerReducer = defaultCustomerState
    state.deviceReducer = defaultDeviceState
    state.errorReducer = defaultErrorState
    state.jobReducer = defaultJobState
    state.loadingReducer = defaultLodingState
    state.navigationReducer = defaultNavigationState
    state.passwordresetReducer = defaultPasswordresetState
    state.reportReducer = defaultReportState
    state.resultReducer = defaultResultState
    state.settingReducer = defaultSettingState
    state.testsReducer = defaultTestsState

    dispatch({
      type: RESET_REDUCERS,
      state
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/resetActions.js